import React from 'react';
import { Pressable, StyleSheet, Platform } from 'react-native';

/** Full-screen tap target to dismiss floating panels/menus when clicking outside. */
export function DismissOverlay({ visible, onDismiss, zIndex = 9 }) {
  if (!visible) return null;

  return (
    <Pressable
      style={[
        Platform.OS === 'web'
          ? { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }
          : StyleSheet.absoluteFillObject,
        { zIndex },
      ]}
      onPress={onDismiss}
      accessibilityLabel="Close panel"
      accessibilityRole="button"
    />
  );
}
